import React from 'react';

/**
 * Component to display when no appointments are found within the specified distance
 */
const NoAppointmentsView = ({ searchDistance, onIncreaseDistance }) => {
  return (
    <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-200 mb-6">
      <h3 className="text-lg font-semibold text-yellow-800 mb-2">
        No Available Appointments Found
      </h3>
      
      <p className="text-gray-700 mb-4">
        We couldn't find any available appointments within {searchDistance}km of your location.
      </p>
      <p className="text-gray-700 mb-4">
        Appointments are very limited at the moment, but we are working hard to increase availability. We do sometimes have slots that are not yet listed so do call us on <a href="tel: +447457411865">
          07457 411 865
        </a> to see if we can get you help straight away.
      </p>
      
      <div className="flex flex-col space-y-4">
        <button
          onClick={onIncreaseDistance}
          className="bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded transition-colors"
        >
          Search within {searchDistance + 20}km
        </button>
        
   
      </div>
    </div>
  );
};

export default NoAppointmentsView;
